export default "assets/images/logo-black-817d13f4.png";